import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';
import {Project} from '../project';
import {ActivityType} from './activity-type';
import {User} from 'projects/core/src/lib/login/data/user';
import {ProjectFile} from '../project-file';
import {Task} from 'projects/desktop/src/app/modules/home-page/data/tasks/task';

@JsonObject('model.activity.project.ProjectActivity')
export class ProjectActivity extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(Boolean, 'ready')
  ready?: boolean;

  @JsonProperty(Boolean, 'isSample')
  isSample?: boolean;

  @JsonProperty(Project, 'project')
  project?: Project;

  @JsonProperty(Boolean, 'isDurationTrimmed')
  isDurationTrimmed?: boolean;

  @JsonProperty(Boolean, 'workloadAware')
  workloadAware?: boolean;

  @JsonProperty(Number, 'deliveryDuration')
  deliveryDuration?: number;

  @JsonProperty([ProjectFile], 'files')
  files?: ProjectFile[];

  @JsonProperty(ActivityType, 'type')
  type?: ActivityType;

  @JsonProperty(DateConverter, 'startDate')
  startDate?: Date;

  @JsonProperty(DateConverter, 'suggestedStartDate')
  suggestedStartDate?: Date;

  @JsonProperty(DateConverter, 'endDate')
  endDate?: Date;

  @JsonProperty(Boolean, 'manualControl')
  manualControl?: boolean;

  @JsonProperty(Boolean, 'ignoreTime')
  ignoreTime?: boolean;

  @JsonProperty(Boolean, 'overlaps')
  overlaps?: boolean;

  @JsonProperty(Number, 'duration')
  duration?: number;

  @JsonProperty(String, 'deliveryInstructions')
  deliveryInstructions?: string;

  @JsonProperty(User, 'user')
  user?: User;

  @JsonProperty([Number], 'additionalUsers')
  additionalUsers?: number[];

  @JsonProperty(Task, 'workOrderTask')
  workOrderTask?: Task;

  @JsonProperty(Boolean, 'isWorkOnSite')
  isWorkOnSite?: boolean;

  @JsonProperty(Boolean, 'isDeliveryOnly')
  isDeliveryOnly?: boolean;

  @JsonProperty(Number, 'serviceOrderId')
  serviceOrderId?: number;

  @JsonProperty(Boolean, 'isDateLock')
  isDateLock?: boolean;

  resourceId?: string;

  chosenForRoute? = false;

  chosenActivityDate?: Date;

}
